import * as React from 'react';
import Page from '../../containers/Page';
import RoutesUtils from '../../utils/routes';
import hashHistory from 'react-router/lib/hashHistory';
import { PageType } from '../../containers/Page/constants';

import { Translate } from 'react-redux-i18n';

class NotFoundPage extends React.Component<{}, {}> {

	private headElement = document.getElementsByTagName('head')[0];

	componentDidMount() {
		if (this.headElement) {
			const linkNode = document.createElement('link');
			linkNode.setAttribute('rel', 'canonical');
			linkNode.setAttribute('href', `${location.origin + location.pathname}#/error404`);
			this.headElement.appendChild(linkNode);
		}
	}

	componentWillUnmount() {
		if (this.headElement) {
			const linkNodes = this.headElement.getElementsByTagName('link');

			for (let i = 0; i < linkNodes.length; i++) {
				const linkNode: HTMLLinkElement = linkNodes[i];

				if (linkNode.rel === 'canonical') {
					const linknodeParent = linkNode.parentElement;
					if (linknodeParent) {
						linknodeParent.removeChild(linkNode);
					}
				}
			}
		}
	}

	render() {
		return (
			<Page
				pageType={PageType.ParametersPage}
				title="messages.page_not_found"
			>
				<a href={`#${RoutesUtils.getPathHome()}${hashHistory.getCurrentLocation().search}`}>
					<Translate value="messages.back_to_home" />
				</a>
			</Page>
		);
	}
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotFoundPage/index.tsx